import type { ErrorComponentProps } from "@tanstack/react-router";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/design/button";
import { EmptyState } from "@/design/surface";
import { errorMessage } from "@/lib/errors";

export function RouteError({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-screen place-items-center p-6">
      <EmptyState icon={<TriangleAlert />} title={errorMessage(t, error)}>
        <Button className="mt-4" onClick={() => (reset ? reset() : window.location.reload())}>
          {t("common.retry")}
        </Button>
      </EmptyState>
    </div>
  );
}
